/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingFilters {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingFilters.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingFilters>): AwsSecurityHubFindingFilters {
        let obj = Object.assign(new AwsSecurityHubFindingFilters(), model);
        AwsSecurityHubFindingFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingFilters>): AwsSecurityHubFindingFilters {
        if (!model) return null;
        return AwsSecurityHubFindingFilters.newInstance(<AwsSecurityHubFindingFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingFilters) {
        if (!obj) return;

        models.AwsSecurityHubFindingFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingFilters): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.AccountFilters.fixupPrototype(this.filters);
        }
        if (this.findings_filter) {
            models.QueryOperator.fixupPrototype(this.findings_filter);
        }
    }

    /**
     * Text filter the tag keys
     */
    text_search_value: string;

    /**
     * Account filters for the tags
     */
    filters: models.AccountFilters;

    findings_filter: models.QueryOperator;

}
